import { Component, OnInit, ViewEncapsulation, ViewChild, OnDestroy, Input } from '@angular/core';
import { MatTable, MatDialog, MatDatepickerInputEvent } from '@angular/material';
import { ScheduleDate, CompanyRef, Uploadable, FundsLogic } from '@akiba/models_bimbo';
import { Subscription } from 'rxjs';
import { SelectionModel } from '@angular/cdk/collections';
import { AppState } from 'projects/bimbo/src/app/models/appState';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { Moment } from 'moment';
import { InfoDialogComponent } from 'projects/bimbo/src/app/dialogs/info-dialog/info-dialog.component';
import * as moment from 'moment';

@Component({
  selector: 'app-lsf-parameters',
  templateUrl: './lsf-parameters.component.html',
  styleUrls: ['./lsf-parameters.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LsfParametersComponent implements OnInit, OnDestroy {

  @ViewChild('datesTable', { static: false }) datesTable: MatTable<ScheduleDate>;
  @ViewChild('companiesTable', { static: false }) companiesTable: MatTable<CompanyRef>;
  displayedCompanyColumns: string[] = ['companyID', 'companyName', 'taxationIdentificationNumber', 'select'];
  displayedFundDatesColumns: string[] = ['Inicio', 'Fin', 'active', 'delete'];

  selectionCompaniesSubscription: Subscription = null;
  appLogicChangesSubscription: Subscription = null;
  generalDataSubscription: Subscription = null;

  selectionCompanies: SelectionModel<CompanyRef> = new SelectionModel<CompanyRef>(true, [], true);
  newRegistrationDate = new ScheduleDate();
  @Input() contentLocation: AppState;
  @Input() fundLogic: FundsLogic;
  constructor(public logicService: LogicService, public dialog: MatDialog) {

    this.generalDataSubscription = this.logicService.dataManager.generalDataLoader.changes.subscribe(r => {
      if (r && r.response) {
        this.doSubscriptions();
      }
    });

    this.logicService.dataManager.generalDataLoader.load();

  }

  ngOnInit() {
  }

  detectFiles(event: any) {

    if (!event.target.files.length) {
      return;
    }

    const file: File = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const aDate = new Date().getTime().toString();
      this.fundLogic.modFund.fileUploaded = new Uploadable();
      this.fundLogic.modFund.fileUploaded.bucket = 'files/' + this.fundLogic.modFund.parametersID + '_' + file.name;
      this.fundLogic.modFund.fileUploaded.name = file.name;
      this.fundLogic.modFund.fileUploaded.file = file;
    };

    reader.readAsDataURL(file);

  }

  switchTo(anIndex: number) {
    this.contentLocation.savingParametersIndex = anIndex;
  }

  setRegistrationDate(type: string, event: MatDatepickerInputEvent<Moment>) {
   // const mexicoTime =  event.value.utc().tz("America/Mexico_City").startOf('day').valueOf().toString();

    if (type === 'starts') {
      this.newRegistrationDate.startDate = event.value.toDate();
    } else if (type === 'ends') {
      this.newRegistrationDate.endDate = event.value.toDate();
    }
  }

  addRegistrationDate() {

    if (!this.newRegistrationDate.startDate) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Las fecha de inicio es requerida.',
          close: 'Aceptar'
        }
      });

      return;

    }

    if (this.isNewDateValid(this.newRegistrationDate)) {

      this.newRegistrationDate.active = true;
      this.fundLogic.modFund.fundDates.push(this.newRegistrationDate);

      this.newRegistrationDate = new ScheduleDate();
      this.newRegistrationDate.startDate = null;
      this.newRegistrationDate.endDate = null;

      if (this.datesTable) {
        this.datesTable.renderRows();
      }

    } else {

      if (!this.newRegistrationDate.endDate && !this.newRegistrationDate.indeterminate) {

        this.dialog.open(InfoDialogComponent, {
          data: {
            message: 'Las fecha de fin de inscripción es requerida si no se especifica como sin fecha fin.',
            close: 'Aceptar'
          }
        });

        return;

      }

    }

  }

  deleteRegistrationDate(index: number) {
    this.fundLogic.modFund.fundDates.splice(index, 1);
    if (this.datesTable) {
      this.datesTable.renderRows();
    }
  }

  isNewDateValid(aPeriodDate: ScheduleDate): boolean {

    let valid = false;
    if (aPeriodDate.startDate) {
      if (!aPeriodDate.indeterminate) {
        if (aPeriodDate.endDate) {
          valid = true;
        }
      } else if (aPeriodDate.indeterminate) {
        if (!aPeriodDate.endDate) {
          valid = true;
        }
      }
    }

    return valid;

  }

  doSubscriptions() {

    if (!this.logicService.dataManager.generalDataLoader.companies || !this.fundLogic || !this.fundLogic.fundParametersChanged) {
      return;
    }

    this.appLogicChangesSubscription = this.fundLogic.fundParametersChanged.subscribe(() => {

      this.selectionCompanies = new SelectionModel<CompanyRef>(true, [], true);

      if (this.fundLogic.modFund) {

        this.logicService.dataManager.generalDataLoader.companies.forEach(cr => {
          const index = this.fundLogic.modFund.includedCompanies.map(ic => ic.companyID).indexOf(cr.companyID);
          if (index >= 0) {
            this.selectionCompanies.select(cr);
          }
        });

        if (this.selectionCompaniesSubscription && !this.selectionCompaniesSubscription.closed) {
          this.selectionCompaniesSubscription.unsubscribe();
          this.selectionCompaniesSubscription = null;
        }

        this.selectionCompaniesSubscription = this.selectionCompanies.changed.subscribe(x => {

          if (x.added.length) {

            x.added.forEach(element => {
              const index = this.fundLogic.modFund.includedCompanies.findIndex(ic => ic.companyID === element.companyID);
              if (index < 0) {
                this.fundLogic.modFund.includedCompanies.push(element);
              }
            });

          } else if (x.removed.length) {

            x.removed.forEach(element => {
              const index = this.fundLogic.modFund.includedCompanies.findIndex(ic => ic.companyID === element.companyID);
              this.fundLogic.modFund.includedCompanies.splice(index, 1);
            });

          }

        });

      }

      if (this.companiesTable) {
        this.companiesTable.renderRows();
      }

      if (this.datesTable) {
        this.datesTable.renderRows();
      }

    });

  }

  reset() {

    this.newRegistrationDate = new ScheduleDate();
    this.newRegistrationDate.startDate = null;
    this.newRegistrationDate.endDate = null;
    this.newRegistrationDate.scheduleDay = null;

  }

  get downloadURL(): string | null {
    const f = this.fundLogic.modFund;
    if (f) {
      return f.downloadLink();
    }
    return null;
  }

  ngOnDestroy(): void {

    if (this.selectionCompaniesSubscription && !this.selectionCompaniesSubscription.closed) {
      this.selectionCompaniesSubscription.unsubscribe();
    }

    if (this.appLogicChangesSubscription && !this.appLogicChangesSubscription.closed) {
      this.appLogicChangesSubscription.unsubscribe();
    }

  }

}
